import(/* webpackMode: "eager" */ "C:\\Users\\User\\Documents\\its all good man 2.0\\magikalcandy\\src\\app\\page.tsx");
